import { PropsWithChildren, useEffect, useRef } from 'react';
import classNames from 'classnames';

import styles from './Expandable.module.scss';

export function Expandable({
  isExpanded,
  children,
  className,
  onExpanded,
  onHidden,
  ...props
}: PropsWithChildren<
  Omit<JSX.IntrinsicElements['div'], 'style' | 'aria-hidden'> & {
    isExpanded: boolean;
    className?: string;
    onExpanded?: () => void;
    onHidden?: () => void;
  }
>): JSX.Element {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      // set the hidden container as inert so that the content will not be focusable
      ref.current.inert = !isExpanded;
    }
  }, [isExpanded]);

  return (
    <div
      className={classNames(styles.container, className)}
      ref={ref}
      aria-hidden={!isExpanded}
      style={{
        maxHeight: isExpanded ? ref.current?.scrollHeight ?? 0 : 0,
      }}
      onTransitionEnd={() => {
        if (isExpanded) {
          onExpanded?.();
        } else {
          onHidden?.();
        }
      }}
      {...props}
    >
      {children}
    </div>
  );
}
